<template>
  <div class="selectedElementDiv">
    <div class="row mt-1" v-for="el in elements">
      <div class="col-md-10 offset-md-1 mb-3">
        <text-element-preview v-if="isElementOfType(el, 'text')" :element="el"></text-element-preview>
        <title-element-preview v-else-if="isElementOfType(el, 'title')" :element="el"></title-element-preview>
        <text-input-element-preview v-else-if="isElementOfType(el, 'inputText')" :element="el"></text-input-element-preview>
        <signature-element-preview v-else-if="isElementOfType(el, 'signature')" :element="el"></signature-element-preview>
        <single-select-element-preview v-else-if="isElementOfType(el, 'singleSelect')" :element="el"></single-select-element-preview>
        <multi-select-element-preview v-else-if="isElementOfType(el, 'multiSelect')" :element="el"></multi-select-element-preview>
        <dropdown-element-preview v-else-if="isElementOfType(el, 'dropdown')" :element="el"></dropdown-element-preview>
        <file-input-element-preview v-else-if="isElementOfType(el, 'file')" :element="el"></file-input-element-preview>

      </div>
    </div>
  </div>
</template>

<script>
import TextElementPreview from './TextElementPreview';
import TitleElementPreview from './TitleElementPreview';
import TextInputElementPreview from './TextInputElementPreview';
import SignatureElementPreview from './SignatureElementPreview';
import SingleSelectElementPreview from './SingleSelectElementPreview';
import MultiSelectElementPreview from './MultiSelectElementPreview';
import DropdownElementPreview from './DropdownElementPreview';
import FileInputElementPreview from "./FileInputElementPreview";

export default {
  name: "FormPreview",
  props: {
    elements: {}
  },
  components: {
    FileInputElementPreview,
    TextElementPreview,
    TitleElementPreview,
    TextInputElementPreview,
    SignatureElementPreview,
    SingleSelectElementPreview,
    MultiSelectElementPreview,
    DropdownElementPreview,
  },
  methods: {
    isElementOfType(el, type) {
      return type === el.element;
    }
  }
}
</script>

<style scoped>
.selectedElementDiv {
  min-height: 80px;
  padding-top: 10px;
  background-color: lightgray;
  border: 2px dotted black;
}

.selectedElementDiv h4 {
  line-height: 80px;
  color: white;
  text-align: center;
}
</style>
